import {Ventrata} from 'types'

let siteKeyPromise: Promise<string> | undefined

/**
 * Resolves the public reCAPTCHA site key from the Ventrata checkout configuration.
 *
 * Memoised at module scope so the config request happens once per page no matter how
 * many widget roots mount, and so the cart pop-up never blocks its first render on a
 * config round-trip.
 *
 * The site key is public and safe to use in the browser. `fingerprintPublicKey` is a
 * migration-period placeholder and is deliberately ignored.
 */
export const getRecaptchaSiteKey = (fetchConfig: () => Promise<Ventrata.Config>): Promise<string> => {
  if (!siteKeyPromise) {
    siteKeyPromise = fetchConfig()
      .then((config) => {
        if (!config.recaptchaEnterpriseSiteKey) {
          throw new Error('The checkout does not provide a reCAPTCHA site key')
        }

        return config.recaptchaEnterpriseSiteKey
      })
      .catch((error) => {
        // Allow a later attempt to retry the configuration request.
        siteKeyPromise = undefined
        throw error
      })
  }

  return siteKeyPromise
}

/** Test hook: drops the memoised site key. */
export const resetRecaptchaSiteKey = () => {
  siteKeyPromise = undefined
}
